import type * as React from 'react';
import { useIntl } from 'react-intl';

import type { VitaEducationExperienceFragment } from '@xing-com/crate-lebenslauf-graphql';

import {
  Container,
  ValueHighlighted,
  DateContainer,
  Date,
  Value,
} from './template-education-item.styled';
import { formatRangeDate } from './template-format-range-date';

type Props = {
  DateStyle?: typeof Date;
  $margin: string;
};

export const TemplateEducationExperienceItem: React.FC<
  VitaEducationExperienceFragment & Props
> = ({
  $margin,
  institution,
  degree,
  startDate,
  endDate,
  isStillStudy,
  courseOfStudy,
  DateStyle,
}) => {
  const intl = useIntl();
  const endDateValue = isStillStudy ? null : endDate;
  const DateComponent = DateStyle ? DateStyle : Date;

  return (
    <Container $margin={$margin}>
      <DateContainer>
        {institution ? (
          <ValueHighlighted>{institution}</ValueHighlighted>
        ) : null}
        {startDate ? (
          <DateComponent>
            {formatRangeDate(intl, startDate, endDateValue)}
          </DateComponent>
        ) : null}
      </DateContainer>
      {degree && <Value>{degree}</Value>}
      {courseOfStudy ? <Value>{courseOfStudy}</Value> : null}
    </Container>
  );
};
